import { render, staticRenderFns } from "./TarefaMobilidadePage.vue?vue&type=template&id=46c3d607"
import script from "./TarefaMobilidadePage.vue?vue&type=script&lang=js"
export * from "./TarefaMobilidadePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports